import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

function Aside() {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const location = useLocation();

  const [nombre, setNombre] = useState("");
  const [rol, setRol] = useState("");
  const [openMenu, setOpenMenu] = useState(null); // Control de submenús

  useEffect(() => {
    // if (!cookies.get("idUsuario")) {
    //   navigate("/");
    // } else {
    //   setNombre(cookies.get("nombre") || "");
    //   setRol(cookies.get("rol") || "");
    // }
  }, [location]);

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* Brand Logo */}
      <NavLink to="/" className="brand-link">
        <img
          src="https://static.vecteezy.com/system/resources/thumbnails/036/105/045/small_2x/artificial-intelligence-ai-processor-chip-icon-symbol-for-graphic-design-logo-web-site-social-media-png.png"
          alt="Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".8" }}
        />
        <span className="brand-text font-weight-light">Agent IA</span>
      </NavLink>

      {/* Sidebar */}
      <div className="sidebar">
        {/* User Panel */}
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img
              src="dist/img/user2-160x160.jpg"
              className="img-circle elevation-2"
              alt="User"
            />
          </div>
          <div className="info">
            {/* <span className="d-block">{formatName(nombre)}</span> */}
            <span className="d-block text-white"  >Stiven Mican</span>
          </div>
        </div>

        {/* Menu */}
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
            {/* Inicio */}
            <li className="nav-item">
              <NavLink to="/inicio" className="nav-link">
                <i className="nav-icon fas fa-tachometer-alt" />
                <p>Inicio</p>
              </NavLink>
            </li>

            {/* Calendario Citas
            <li className="nav-item">
              <NavLink to="/calendario_citas" className="nav-link">
                <i className="fas fa-calendar nav-icon"></i>
                <p>Calendario Citas</p>
              </NavLink>
            </li> */}

            <li className="nav-item">
              <NavLink to="/historial_chats" className="nav-link">
                <i className="fas fa-history nav-icon"></i>
                <p>Historial Chats</p>
              </NavLink>
            </li>

            {/* Rips JSON */}
            {/* <li
              className={`nav-item has-treeview ${
                openMenu === "rips" ? "menu-open" : ""
              }`}
            >
              <a
                href="#!"
                className="nav-link"
                onClick={() => toggleMenu("rips")}
              >
                <i className="nav-icon fas fa-file-code" />
                <p>
                  Rips JSON
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <NavLink to="/consulta_envio" className="nav-link">
                    <i className="fas fa-paper-plane nav-icon"></i>
                    <p>Consulta y Envío</p>
                  </NavLink>
                </li>
              </ul>
            </li> */}

            {/* Solo para Admin */}
            {/* {rol === "Admin" && (
              <> */}
            {/* <li className="nav-item">
                  <NavLink to="/reportes" className="nav-link">
                    <i className="nav-icon fas fa-chart-bar" />
                    <p>Reportes</p>
                  </NavLink>
                </li> */}

            <li
              className={`nav-item has-treeview ${openMenu === "config" ? "menu-open" : ""
                }`}
            >
              <a
                href="#!"
                className="nav-link"
                onClick={() => toggleMenu("config")}
              >
                <i className="nav-icon fas fa-cogs" />
                <p>
                  Configuración
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">

                            
                <li className="nav-item">
                  <NavLink to="/telefonos_notificacion" className="nav-link">
                    <i className="fas fa-phone-square nav-icon " />
                    <p>Telefonos Notificación</p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/gestion_usuarios" className="nav-link">
                    <i className="fas fa-user-cog nav-icon"></i>
                    <p>Usuarios del sistema</p>
                  </NavLink>
                </li>

              </ul>
            </li>
            {/* </>
            )} */}
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Aside;
